import type { JSX } from 'react'
import type { SkinView, SkinViews } from '../../index.h'

import { isArray } from '~/shared/helpers'
import { key, useSkin } from '../core'
import { Recursive } from './Recursive'

interface Props {
  name: string
  from?: SkinViews | Promise<SkinViews> | (() => SkinViews | Promise<SkinViews>)
  [key: string]: unknown // any additional props, will be propogated to ALL children
}

// RenderSkin.whyDidYouRender = true
RenderSkin.displayName = 'RenderSkin'
export function RenderSkin({
  name,
  from,
  ...props
}: Props): JSX.Element | null {
  const skin: SkinView | SkinView[] | null = useSkin(name, from)

  if (skin == null) {
    return <div />
  }

  return isArray(skin) ? (
    <>
      {skin.map((skin, i) => (
        <Recursive {...props} skin={skin} key={key(skin, i)} />
      ))}
    </>
  ) : (
    <Recursive {...props} skin={skin} key={key(skin)} />
  )
}
